<template>
  <div id="SafteElectronic" class="safte-electronic-page">
    <net-pa-list-page-card
      v-if="Level < 3"
      :title="signCardTitle"
      :description="signCardDescription"
      :show-back="Level === 0"
    >
      <div class="safte-electronic-content py-3 px-0">
        <div v-if="Level == 0" class="col-12 px-0">
          <sign-list
            @introduceNew="OpenLevel1()"
            @CompeleteSign="OpenLevel2"
            @SafteRecieve="OpenLevel3"
            @ListSafte="OpenLevel5"
          ></sign-list>
        </div>
        <div v-if="Level == 1" class="col-12 px-0">
          <Introduce-signature
            @introduce_success="succesIntroduce"
          ></Introduce-signature>
        </div>
        <div v-if="Level == 2" class="col-12 px-0">
          <create-sign
            @click="Level = 0"
            @create_success="Level = 0"
            :IntroduceInfo="IntroduceInfo"
          ></create-sign>
        </div>
        <div v-if="Level != 0" class="safte-electronic-actions">
          <button type="button" @click="Level = 0" class="btn btn-danger">
            انصراف
          </button>
        </div>
      </div>
    </net-pa-list-page-card>

    <net-pa-list-page-card
      v-if="Level != 1 && Level != 2"
      :title="safteCardTitle"
      :description="safteCardDescription"
      :show-back="false"
    >
      <div class="safte-electronic-content py-3 px-0">
        <div v-if="Level == 3" class="col-12 px-0">
          <SafteReceive @SafteRecieved="OPenLevel0"></SafteReceive>
        </div>
        <div v-if="Level == 0" class="col-12 px-0">
          <safte-list
            :key="safteListKey"
            @SignF="OpenLevel6"
            @NewSafte="OpenLevel3"
            :Sign="Sign"
          ></safte-list>
        </div>
        <div v-if="Level == 6" class="col-12 px-0">
          <sign-Finally
            @SignDone="DoneSigning"
            :SafteToSign="SafteToSign"
          ></sign-Finally>
        </div>
        <div v-if="Level != 0" class="safte-electronic-actions">
          <button type="button" @click="Level = 0" class="btn btn-danger">
            انصراف
          </button>
        </div>
      </div>
    </net-pa-list-page-card>
  </div>
</template>

<script>
import NetPaListPageCard from "../../Tools/NetPa/NetPaListPageCard.vue";
import CreateSign from "./CreateSign.vue";
import IntroduceSignature from "./IntroduceSignature.vue";
import SafteList from "./SafteList.vue";
import SafteReceive from "./Safte_Receive.vue";
import SignList from "./SignList.vue";
import SignFinally from "./SignFinally.vue";

export default {
  components: {
    NetPaListPageCard,
    IntroduceSignature,
    CreateSign,
    SignList,
    SafteReceive,
    SafteList,
    SignFinally,
  },
  data() {
    return {
      SafteToSign: null,
      Level: 0,
      IntroduceInfo: {},
      SafteReceiveData: {},
      Sign: {},
      safteListKey: 0,
    };
  },
  computed: {
    signCardTitle() {
      if (this.Level === 1 || this.Level === 2) {
        return "ثبت امضا";
      }
      return "لیست امضاهای ثبت شده";
    },
    signCardDescription() {
      if (this.Level === 1) {
        return "از طریق این فرم می‌توانید امضای الکترونیکی خود را معرفی کنید";
      }
      if (this.Level === 2) {
        return "اطلاعات امضا را تکمیل و فرآیند ثبت را نهایی کنید";
      }
      return "از طریق این فرم می‌توانید امضاهای ثبت‌شده خود را مشاهده و مدیریت کنید";
    },
    safteCardTitle() {
      if (this.Level === 3) {
        return "دریافت سفته";
      }
      if (this.Level === 6) {
        return "امضای سفته";
      }
      return "لیست سفته‌ها";
    },
    safteCardDescription() {
      if (this.Level === 3) {
        return "از طریق این فرم می‌توانید سفته الکترونیکی جدید دریافت کنید";
      }
      if (this.Level === 6) {
        return "سفته انتخاب‌شده را بررسی و امضای نهایی را انجام دهید";
      }
      return "از طریق این فرم می‌توانید سفته‌های الکترونیکی خود را مشاهده و مدیریت کنید";
    },
  },
  methods: {
    succesIntroduce(data) {
      this.Level++;
      console.warn(data);
      this.IntroduceInfo = data;
    },
    OPenLevel0() {
      this.Level = 0;
    },
    OpenLevel1() {
      this.Level = 1;
    },
    OpenLevel2(sign) {
      this.IntroduceInfo = {
        national_code: sign.national_code,
        ref_id: sign.request_id,
        fa_first_name: sign.fa_first_name,
        fa_last_name: sign.fa_last_name,
        request_id: sign.request_id,
      };
      this.Level = 2;
    },
    OpenLevel3(sign) {
      this.Level = 3;
      this.SafteReceiveData = sign;
    },
    OpenLevel5(sign) {
      this.Level = 5;
      if (sign) {
        this.Sign = sign;
        console.warn(this.Sign);
      }
    },
    OpenLevel6(sign) {
      this.Level = 6;
      this.SafteToSign = sign;
    },
    DoneSigning() {
      this.Level = 0;
      this.safteListKey++;
    },
  },
};
</script>

<style scoped>
.safte-electronic-page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.safte-electronic-content {
  width: 100%;
}

.safte-electronic-actions {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(42, 63, 84, 0.08);
  direction: rtl;
}

.safte-electronic-actions .btn {
  min-width: 6rem;
  border-radius: 8px;
}
</style>
